document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".product--root").forEach(function (card) {

    var jsonEl = card.querySelector(".variant-json");
    if (!jsonEl) return;

    var variantData = JSON.parse(jsonEl.textContent);

    var priceBox = card.querySelector(".product-price");
    var compareBox = card.querySelector(".compare-price");
    var qtyInput = card.querySelector(".qty-input");
    var button = card.querySelector(".product-card-btn");
    var radios = card.querySelectorAll("input[name='id']");

    // Initial prices (in cents)
    var currentPrice = parseInt(priceBox.dataset.basePrice);
    var currentComparePrice = compareBox
      ? parseInt(compareBox.dataset.comparePrice)
      : 0;

    // FORMAT MONEY FUNCTION
    function formatMoney(cents) {
      return "$ " + (cents / 100).toFixed(2);
    }

    // UPDATE TOTAL (PRICE × QTY)
    function updateTotal() {

      var qty = parseInt(qtyInput.value) || 1;

      var total = currentPrice * qty;
      priceBox.innerHTML = formatMoney(total);

      // Compare price handling
      if (currentComparePrice && currentComparePrice > currentPrice) {

        if (!compareBox) {
          compareBox = document.createElement("span");
          compareBox.className = "compare-price";
          priceBox.parentNode.insertBefore(compareBox, priceBox);
        }

        var compareTotal = currentComparePrice * qty;
        compareBox.innerHTML = formatMoney(compareTotal);
        compareBox.style.display = "inline-block";

      } else {
        if (compareBox) {
          compareBox.style.display = "none";
        }
      }
    }

    // VARIANT CHANGE
    radios.forEach(function (radio) {

      radio.addEventListener("change", function () {

        var selectedId = parseInt(this.value);

        var selectedVariant = variantData.find(function (v) {
          return v.id === selectedId;
        });

        if (selectedVariant) {

          currentPrice = selectedVariant.price;
          currentComparePrice = selectedVariant.compare_at_price || 0;

          updateTotal();

          // Button state per variant
          if (selectedVariant.available) {
            button.disabled = false;
            button.innerHTML = "Buy Now →";
          } else {
            button.disabled = true;
            button.innerHTML = "Sold Out";
          }
        }
      });

    });

    // QTY BUTTONS
    if (card.querySelector(".plus")) {
      card.querySelector(".plus").addEventListener("click", function () {
        qtyInput.value = parseInt(qtyInput.value) + 1;
        updateTotal();
      });
    }

    if (card.querySelector(".minus")) {
      card.querySelector(".minus").addEventListener("click", function () {
        if (parseInt(qtyInput.value) > 1) {
          qtyInput.value = parseInt(qtyInput.value) - 1;
          updateTotal();
        }
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener("input", function () {
        if (this.value < 1) this.value = 1;
        updateTotal();
      });
    }

  });

    // Product Varient  
    document.addEventListener("change", function(e){
        if(e.target.matches(".variant-radio-wrapper input[type='radio']")){
            var wrapper = e.target.closest(".variant-radio-wrapper");
            wrapper.querySelectorAll(".variant-radio-item").forEach(function(label){
            label.classList.remove("checked");
            });
            e.target.closest(".variant-radio-item").classList.add("checked");
        }
   });

});


$(document).ready(function () {

  /* ==========================
     PARALLAX EFFECT
  ========================== */

  document.addEventListener("mousemove", function (e) {

    $(".object").each(function () {

      var moving_value = $(this).data("value");

      var x = (e.clientX * moving_value) / 250;
      var y = (e.clientY * moving_value) / 250;

      $(this).css("transform", "translate(" + x + "px, " + y + "px)");

    });

  });


  /* ==========================
     COUNTER ANIMATION
  ========================== */

  function animateCounter(element) {

    if (!element.hasClass("ms-animated")) {

      var maxVal = parseInt(element.data("max"));
      var suffix = element.data("suffix") || ""; // optional

      element.addClass("ms-animated");

      $({ countNum: 0 }).animate(
        { countNum: maxVal },
        {
          duration: 2000,
          easing: "swing",
          step: function () {
            element.text(Math.floor(this.countNum) + suffix);
          },
          complete: function () {
            element.text(maxVal + suffix);
          }
        }
      );
    }
  }


  /* ==========================
     CHECK ELEMENT IN VIEW
  ========================== */

  function checkVisible() {

    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();

    $("span[data-max]").each(function () {

      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      if (elementBottom > windowTop && elementTop < windowBottom) {
        animateCounter($(this));
      }

    });

  }

  // Run on scroll
  $(window).on("scroll", function () {
    checkVisible();
  });

  // Run once on load
  checkVisible();

  // Hero Slider Section
  $('.hero-banner-section').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 800,
      dots: false,
      arrows: true,
      infinite: true,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/1084/2218/files/preview_arrow.svg" alt="Previous"></button>',
      nextArrow: '<button type="button" class="custom-next"><img src="https://cdn.shopify.com/s/files/1/1084/2218/files/next_arrow.svg" alt="Next"></button>',
      responsive: [
        {
            breakpoint: 768, // 767px and below
            settings: {
                dots: true,
                arrows: false
            }
        }
    ]
  });

  // Blog Slider Mobile
  function initBlogMobileSliderBlog() {
    var $slider = $('.blog-listing-row-grid');

    if ($(window).width() <= 767) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          infinite: true,
          speed: 600,
          autoplay: false,
          adaptiveHeight: true,
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
}

initBlogMobileSliderBlog();

//Letest Product Image Gallary  
$(window).on('resize orientationchange', function () {
    initBlogMobileSliderBlog();
});

function initBlogMobileSlider() {
  var $slider = $('.lat-pro-gallery');

  if ($(window).width() <= 767) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 600,
        autoplay: false,
        adaptiveHeight: true,

        responsive: [
          {
            breakpoint: 501,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

initBlogMobileSlider();

$(window).on('resize orientationchange', function () {
  initBlogMobileSlider();
});
});
